import {EVENT_LOGIN, EVENT_LOGIN_SUCCESS, EVENT_LOGIN_ERROR, EVENT_LOGOUT} from '../actions/authactions'
import {getToken} from '../../storage'


const token = getToken()
let defaultState = {}

if(typeof token !== "undefined") {
  defaultState =  Object.assign({}, {authenticated:true, token: token})
}


function loginReducer(state=defaultState, action) {
  switch (action.type) {
    case EVENT_LOGOUT:
      return {}
    case EVENT_LOGIN:
      return Object.assign({}, state, {logging_in: true, authenticated: false})
    case EVENT_LOGIN_ERROR:
      return Object.assign({}, state, {logging_in: false, logging_error: action.data})
    case EVENT_LOGIN_SUCCESS:
      return Object.assign({}, state, {logging_in: false, authenticated: true, token: action.data})
    default:
      return state
  }

}

export default loginReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/auth.js